import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <nav className="navigation-wrapper">
        <div className="navigation-container">
          <Link to="/">
            <div className="navigation-thq-navigation-logo-elm1 navigation-logo">
              <span className="section-title">ClearPath Digital</span>
            </div>
          </Link>
          <div className="navigation-desktop">
            <ul className="navigation-links">
              <li>
                <Link to="/website-creation-main-service">
                  <div className="navigation-thq-navigation-link-elm1 navigation-link">
                    <span>Websites</span>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/process-page">
                  <div className="navigation-thq-navigation-link-elm2 navigation-link">
                    <span>Process</span>
                  </div>
                </Link>
              </li>
              <li>
                <a href="/pricing">
                  <div className="navigation-link">
                    <span>Pricing</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="/about">
                  <div className="navigation-link">
                    <span>About</span>
                  </div>
                </a>
              </li>
            </ul>
            <div className="navigation-actions">
              <Link to="/contact-book-a-call">
                <div className="navigation-thq-btn-elm1 btn btn-sm btn-primary">
                  <span>Book a Strategy Call</span>
                </div>
              </Link>
              <a
                href="https://demo.clearpathdigital.co"
                target="_blank"
                rel="noreferrer noopener"
              >
                <div className="navigation-thq-btn-elm2 btn btn-sm btn-primary">
                  <span className="navigation-text15">Look at the demo</span>
                </div>
              </a>
            </div>
          </div>
          <button
            id="navToggle"
            aria-label="Toggle Menu"
            aria-expanded="false"
            className="navigation-mobile-toggle"
          >
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M4 6h16M4 12h16M4 18h16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>
        </div>
        <div>
          <div className="navigation-container3">
            <Script
              html={`<script>
  document.querySelectorAll('a[href^="/"]').forEach(link => {
  link.addEventListener('click', function() {
    window.scrollTo({top: 0, behavior: 'smooth'});
  });
});
</script>`}
            ></Script>
          </div>
        </div>
      </nav>
      <div id="mobileOverlay" className="navigation-mobile-overlay">
        <div className="navigation-overlay-header">
          <a href="/">
            <div className="navigation-logo">
              <span className="section-title">AGENCY_NAME</span>
            </div>
          </a>
          <button
            id="navClose"
            aria-label="Close Menu"
            className="navigation-mobile-close"
          >
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>
        </div>
        <div className="navigation-overlay-content">
          <ul className="navigation-overlay-links">
            <li>
              <a href="/website-creation">
                <div className="navigation-overlay-link">
                  <span>Website Creation</span>
                </div>
              </a>
            </li>
            <li>
              <a href="/process">
                <div className="navigation-overlay-link">
                  <span>Our Process</span>
                </div>
              </a>
            </li>
            <li>
              <a href="/case-studies">
                <div className="navigation-overlay-link">
                  <span>Case Studies</span>
                </div>
              </a>
            </li>
            <li>
              <a href="/pricing">
                <div className="navigation-overlay-link">
                  <span>Pricing &amp; Packages</span>
                </div>
              </a>
            </li>
            <li>
              <a href="/about">
                <div className="navigation-overlay-link">
                  <span>About the Agency</span>
                </div>
              </a>
            </li>
          </ul>
          <div className="navigation-overlay-footer">
            <a href="/contact">
              <div className="btn btn-primary btn-lg">
                <span>Book a Free Strategy Call</span>
              </div>
            </a>
            <a href="/audit">
              <div className="btn-outline btn btn-lg">
                <span>Get a Free Website Audit</span>
              </div>
            </a>
          </div>
        </div>
        <div>
          <div className="navigation-container5">
            <Script
              html={`<script>
  document.querySelectorAll('a[href^="/"]').forEach(link => {
  link.addEventListener('click', function() {
    window.scrollTo({top: 0, behavior: 'smooth'});
  });
});
</script>`}
            ></Script>
          </div>
        </div>
      </div>
      <div className="navigation-container6">
        <div className="navigation-container7">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.navigation-link, .navigation-mobile-overlay {
  transition: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="navigation-container8">
        <div className="navigation-container9">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
const navToggle = document.getElementById('navToggle');
const navClose = document.getElementById('navClose');
const mobileOverlay = document.getElementById('mobileOverlay');
const body = document.body;

function openMenu() {
  mobileOverlay.style.display = 'flex';
  mobileOverlay.setAttribute('data-open', 'true');
  navToggle.setAttribute('aria-expanded', 'true');
  body.style.overflow = 'hidden';
}

function closeMenu() {
  mobileOverlay.style.display = 'none';
  mobileOverlay.setAttribute('data-open', 'false');
  navToggle.setAttribute('aria-expanded', 'false');
  body.style.overflow = '';
}

navToggle.addEventListener('click', openMenu);
navClose.addEventListener('click', closeMenu);

mobileOverlay.addEventListener('click', (e) => {
  if (e.target.classList.contains('navigation-overlay-link') || e.target.closest('.btn')) {
    closeMenu();
  }
});

window.addEventListener('resize', () => {
  if (window.innerWidth > 767 && mobileOverlay.getAttribute('data-open') === 'true') {
    closeMenu();
  }
});
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
